export const defaultStyle = {
  containerWrapper: "test containerWrapper bg-grayWhite",
  headingWrapper: "headingWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  Heading:
    "text-purple font-MDLZBiteType text-[36px] md:text-[60px] px-[35px] md:px-[15px] mb-60 tracking-normal font-light",
  container:
    "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto flex flex-wrap border-b-1 border-solid md:border-0 mb-[0px] md:mb-[90px] box-border pl-[35px] md:pl-[0px]",
  Content:
    "md:flex-1 md:border-r-1 md:border-solid md:border-gray-400 last:border-none relative px-[15px] box-border mr-[0.667px] b-r-0 h-[211.792px] md:h-[381.688px] lg:h-[281.781px] mx-[30px]",
  Content2:
    "text-[14px] font-Regular font-bold font-stretch tracking-[0.022em] mb-[44px] mt-[0px] text-black hover:text-red-700 hover:underline",
  title:
    "md:text-[48px] text-[24px] mb-[10px] font-Light font-light tracking-normal text-green md:mb-[30px] leading-[28.8px] md:leading-[57.6px] ",
  Button: "flex flex-col items-center justify-center",
  Button2:
    "font-bold text-lg text-center cursor-pointer uppercase font-Regular bg-purple-900 border-2 rounded-full w-[160px] h-[60px] px-45 py-14  box-border text-white hover:opacity-[70%]",
  description:
    "text-[14px] md:text-[21px] text-black font-Regular mb-[10px] font-light tracking-[0.53px] [&>div>p>a]:font-bold [&>div>p>a]:tracking-[0.53px] md:[&>div>p>a]:!tracking-[2.2px] [&>div>p>a:hover]:underline [&>div>p>strong]:font-bold",
}

export const TWO_COLUMN_LINKS_BG_WHITE = {
  ...defaultStyle,
  containerWrapper: "containerWrapper bg-white",
  description:
    "text-[14px] md:text-[16px] text-black font-Regular text-[24px] mb-[10px] font-light tracking-[0.53px] [&>div>p>strong]:font-bold h-[610px] lg:h-[300px]",
  title:
    "md:text-[36px] text-[24px] mb-[10px] font-Light font-light tracking-normal text-green md:mb-[30px] leading-[28.8px] md:leading-[43px] ",
  descriptionLink:
    "font-bold text-[21px] text-center cursor-pointer uppercase font-Regular bg-purple-900 border-2 rounded-full w-[160px] h-[60px] px-45 py-18 box-border text-purple hover:text-white hover:bg-[#724D8D] hover:border-[#724D8D]",
  Content:
    "md:flex-1 md:border-r-1 md:border-solid md:border-gray-400 last:border-none relative pl-[15px] box-border mr-[0.667px] b-r-0 h-[760px] lg:h-[444px] mx-[30px]",
}

export const FOUR_COL_GRID = {
  ...defaultStyle,
  containerWrapper: "containerWrapper bg-grayWhite py-[40px]",
  Content:
    "flex-1 md:border-r-1 md:border-solid md:border-gray-400 last:border-none relative pr-[50px] md:pl-[15px] box-border mr-[0.667px] b-r-0 h-[247.792px] md:h-[576.094px] lg:h-[292.594px] md:max-w-[25%] mx-[30px] md:mx-[0px]",
  description:
    "text-[14px] md:text-[21px] text-black font-Regular text-[24px] mb-[10px] font-light tracking-[0.53px] box-border",
  container:
    "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto flex flex-wrap border-b-1 border-solid md:border-0 mb-[0px] mb-[70px] md:mb-[90px] box-border pl-[35px] lg:px-[60px]",
}

export const MULTI_LINKS = {
  mainContainerWrapper: "bg-grayWhite",
  containerWrapper:
    "containerWrapper py-[40px] px-[15px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto ",
  Heading:
    "text-purple md:max-w-md lg:max-w-lg xl:max-w-xl font-MDLZBiteType text-[36px] mx-auto tracking-[1.2px] leading-[43.2px] md:leading-[72px] font-light md:text-[60px] mb-[25px] md:mb-[50px] text-center md:text-left",
  container:
    "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto block md:flex flex-wrap relative block box-border font-normal px-15 md:px-[0px]",
  Content:
    " flex-1 md:border-r-1 md:last:border-none text-[14px] tracking-[2.8px] md:tracking-[4.2px] leading-[30px] text-purple font-Regular font-bold md:text-[21px] uppercase cursor-pointer md:mr-[50px] text-center md:text-left box-border mb-[25px] md:mb-[0px]",
  Content2:
    "text-[14px] font-Calibri font-bold font-stretch tracking-[0.022em] mb-[44px] mt-[0px] text-black hover:text-red-700 hover:underline",
  title:
    " text-[14px] md:text-[21px] text-purple hover:text-orange hover:underline font-Regular text-center md:text-leftx",
  description:
    " text-[21px] text-black hover:text-orange-700 hover:underline font-Regular",
  descriptionText: "pb-16",
  Button: "flex flex-col items-center justify-center",
  Button2:
    "font-bold text-lg text-center cursor-pointer uppercase font-calibri bg-purple-900 border-2 rounded-full w-[160px] h-[60px] px-45 py-14  box-border text-white hover:opacity-[70%]",
  headingWrapper:
    "headingWrapper max-w-[200px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
}

export const MENU_TABS = {
  ...defaultStyle,
  Heading: "test lg:flex md:flex bg-[#f8f8f8] mt-40",
  Content: "md:mb-[80px] w-full px-35 pt-30 pb-15 md:px-0 md:pt-0 md:pb-0",
  container:
    "md:flex flex-nowrap mb-[0px] border-b border-b-transparent lg:pr-0 px-0",
  title:
    "title md:text-[28px] text-[14px] md:bg-white md:bg-white pb-16 md:p-15 text-black font-MDLZBiteType ",
  description: "md:my-45 md:px-15",
}

export const THREE_COL_GRID = {
  ...defaultStyle,
  containerWrapper:
    "climateContainer md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px]",
  container: "ContainerClimate md:block lg:flex flex",
  title:
    "md:text-[28px] text-[16px] mb-[10px] font-MDLZBiteType tracking-normal text-black text-center md:text-center lg:text-left",
  titleContent: "titleContent px-[15px]",
  headingWrapper: "climateWrapper py-[50px]",
  Content: "titleContent md:border-gray-400 px-[10px] pb-[25px] flex-1",
  description:
    "text-black font-Regular text-[14px] md:text-[21px] lg:text-[24px] mb-[10px] font-light tracking-[0.53px] leading-[31.5px] text-left",
}

export const THREE_COL_GRID_PARTIAL_GRID = {
  ...defaultStyle,
  containerWrapper:
    "containerWrapper contentWrapperPartial md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto [&>div>div]:flex max-md:[&>div>div]:flex-wrap mb-[35px] max-md:px-[35px]",
  Heading: "text-[21px] px-15",
  headingWrapper: "climateWrapper mb-[35px]",
  container: "hidden",
}

export const THREE_COL_GRID_WITH_LIST = {
  ...THREE_COL_GRID,
  Heading:
    "text-black leading-[19.2px] md:leading-[33.33px] tracking-normal font-MDLZBiteType text-[16px] md:text-[28px] px-[35px] md:px-[15px]  tracking-normal font-light",
  containerWrapper:
    "climateContainer md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[10px]",
  container: "ContainerClimate block md:flex",
  titleContent: "titleContent",
  description:
    "text-black font-Regular text-[14px] md:text-[21px] mb-[10px] font-light tracking-[0.53px] leading-[31.5px] text-left pl-[25px] list-disc",
  title:
    "md:text-[21px] text-[24px] mb-[35px] font-Regular tracking-[0.53px] leading-[31.5px] text-black text-left md:text-left lg:text-left font-bold px-[20px] md:px-[20px] lg:px-[0px]",
}

export const MULTIPLE_FOOTER_LINKLIST = {
  containerWrapper: "containerWrapper bg-grayWhite py-[40px]",
  headingWrapper:
    "headingWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[0px] md:px-[15px] text-center md:text-left max-md:mx-20",
  Heading:
    "text-purple heading-title font-MDLZBiteType text-[36px] md:text-[60px] mb-[25px] lg:mb-[50px] tracking-normal lg:tracking-[1.2px] font-light leading-[1.2] text-center md:text-left",
  container: "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto flex flex-wrap", //border-b border-b-ashBlack
  Content: "w-full px-[35px] md:px-[15px] text-center md:text-left mb-[25px]",
  Content2:
    "text-[14px] font-Regular font-bold font-stretch tracking-[0.022em] mb-[44px] mt-[0px] text-black hover:text-red-700 hover:underline",
  title:
    " text-21 text-purple uppercase tracking-[2.8px] md:tracking-[4.2px] leading-[30px] font-bold mb-[10px] font-Regular  md:mb-[30px] focus:text-orange hover:text-orange hover:underline",
  Button: "flex flex-col items-center justify-center",
  Button2:
    "font-bold text-lg text-center cursor-pointer uppercase font-Regular bg-purple-900 border-2 rounded-full w-[160px] h-[60px] px-45 py-14  box-border text-white hover:opacity-[70%]",
  description:
    "text-[21px] text-black font-Regular text-[24px] mb-[10px] font-light tracking-[0.53px]",
}
export const HEADING_PURPLE_TWO = {
  containerWrapper:
    "containerWrapper w-[100%] px-[15px] mx-auto box-border align-center md:py-[40px] md:block ",
  headingWrapper:
    "headingWrapper md:max-w-md md:w-[100%] md:px-[15px] md:m-auto box-border lg:max-w-lg xl:max-w-xl mx-auto",
  Heading:
    "text-purple font-MDLZBiteType text-[36px] md:text-[60px] px-[20px] mb-[25px] max-w-[200px] md:max-w-[720px] lg:max-w-[1334px] md:mb-[50px] mx-auto md:leading-[1.2] tracking-[1.2px] font-light mt-0 box-border",
  container:
    "container md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto flex flex-wrap mx-[15px] box-border",
  Content: "Content relative w-[100%] box-border ",
  title:
    "h-[30px] mb-0 lg:pl-[113px] tracking-[2.8px] block leading-[30px] uppercase font-Regular text-[14px] md:text-[21px] font-bold text-purple box-border cursor-pointer mb-[25px] px-[35px] pb-[30px]",
  description:'description',
}

export const COL_GRID_PURPLE_TEXT = {
  ...THREE_COL_GRID,
  containerWrapper:
    "climateContainer md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[35px] md:px-[0px] py-[30px] lg:py-[50px] test",
  container: "container",
  linkwrap: "linkwrap lg:grid lg:grid-cols-3",
  linkContainer: "linkContainer",
}
export const Appendix_THREE_COLUMN = {
  containerWrapper:
    "containerWrapper w-[100%] px-[35px] lg:px-[15px] mb-[50px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  headingWrapper: "headingWrapper",
  Heading:
    "font-MDLZBiteType text-black text-[16px] text-center lg:text-left lg:text-[28px] mb-[10px]",
  container: "container md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto lg:flex md:flex",
  Content: "Content flex-1",
  title: "",
  descriptionList: "descriptionList",
  description: "description",
  descriptionText:
    "whitespace-break-spaces mr-[15px] text-[16px] font-Regular [&>p]:break-all",
}

export const HEADING_WITH_TEXT = {
  ...defaultStyle,
  containerWrapper: "test containerWrapper bg-grayWhite py-[45px]",
  Content:
    "md:border-r-1 md:w-[30%] lg:w-[33%] md:border-gray-400 last:border-none w-full relative md:first:pl-[15px] md:first:pr-[50px] mx-[30px] md:mx-[0px] md:px-[50px] md:last:pl-[50px] md:last:pr-[15px] box-border b-r-0 pb-[25px]",
}

export const CONTACT_US_TABLE = {
  ...defaultStyle,
  Content:
    "md:border-r-1 md:w-[25%] xl:w-[29%] md:border-gray-400 h-73 last:border-none mb-[80px] w-full relative pr-[30px] box-border mx-[27px] b-r-0 pb-[25px]",
  containerWrapper: "containerWrapper123 bg-[#fff] lg:px-[15px] lg:mx-auto",
  container:
    "lg:max-w-lg xl:max-w-xl mx-auto flex mb-[70px] pl-[35px] md:pl-0 md:justify-center lg:justify-start",
  title:
    "md:text-[48px] text-[24px] mb-[10px] font-Light tracking-normal text-[#287819] md:mb-[30px] md:leading-[57.6px]",
  description:
    "text-[14px] md:text-[21px] text-black font-Regular mb-[10px] font-light tracking-[0.53px] [&>div>p>a]:text-[14px] [&>div>p>a]:font-bold [&>div>p>a]:tracking-[0.53px] [&>div>p>a]:lg:text-[21px] [&>div>p>a]:lg:tracking-[2.2px] [&>div>p>a]:text-[#4f2170] hover:[&>div>p>a]:underline [&>div>p>strong]:font-bold [&>div>.firstPara]:mb-[16px]",
}

export const THREE_COL_VIDEOS = {
  containerWrapper:
    "containerWrapper w-[100%] px-[20px] md:px-[35px] lg:px-[15px]  mb-[50px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto relative pb-[80px] h-full",
  headingWrapper: "headingWrapper",
  Heading:
    "font-Regular text-green text-[16px] text-center lg:text-left lg:text-[48px] mb-[35px]",
  container:
    "container md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto lg:flex md:flex pt-[50px]",
  Content: "Content flex-1",
  title: "",
  descriptionList: "descriptionList",
  description: "description",
  descriptionText:
    "whitespace-break-spaces mr-[15px] text-[14px] md:text-[21px] font-Regular mb-[20px] lg:mb-0",
}

export const THREE_COL_VIDEOS_OUTSIDE_TAB = {
  ...THREE_COL_VIDEOS,
  containerWrapper:
    "countryContainerWrap w-full md:w-full mb-[50px] md:mx-10  py-[30px] lg:py-[50px]",
  headingWrapper:
    "headingWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto mb-[30px] lg:mb-[50px]",
  Content:
    "flex flex-col-reverse w-full md:w-full lg:w-1/3 md:items-center px-[18px]",
  title: "three-col-title text-21 font-bold px-[24px] max-md:pl-0 max-md:mb-[20px]",
  container:
    "container md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto lg:flex md:flex items-baseline md:pr-[15px]",
  Heading:
    "md:text-[48px] text-[24px] mb-[10px] font-Light font-light tracking-normal text-green md:mb-[30px] leading-[28.8px] md:leading-[57.6px] ",
}
export const TWO_COL_VIDEOS_OUTSIDE_TAB = {
  ...THREE_COL_VIDEOS,
  headingWrapper:
  "headingWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto mb-[30px] lg:mb-[50px]",
  containerWrapper:
    "w-full md:w-full py-[5px] lg:py-[50px] px-[35px] lg:px-[0px]",
  Content:
    "flex flex-col-reverse w-full md:w-full lg:w-1/2 lg:px-[15px] mb-[30px] lg:mb-0",
  title: "text-21 font-bold max-md:pl-0 max-md:mb-[20px] text-start lg:px-[15px]",
  container:
    "twoColumnVideoWrapper container md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto lg:flex items-baseline",
}

export const TWO_COL_VIDEOS_OUTSIDE_TAB_PURPLE_TITLE = {
  ...THREE_COL_VIDEOS,
  headingWrapper:
  "headingWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto mb-[30px] lg:mb-[50px] lg:px-[15px]",
  containerWrapper:
    "w-full md:w-full py-[5px] lg:py-[50px] px-[35px] lg:px-[0px]",
  Content:
    "flex flex-col-reverse w-full md:w-full lg:w-1/2 lg:px-[15px] mb-[30px] lg:mb-0",
  title: "text-21 font-bold max-md:pl-0 max-md:mb-[20px] text-start lg:px-[15px]",
  container:
    "twoColumnVideoWrapper container md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto lg:flex items-baseline",
  Heading:
    "headingPurple text-[36px] md:text-[60px] font-MDLZBiteType tracking-[1.2px] leading-[43.2px] text-purple mb-[25px] mx-auto max-md:px-[15px] pb-[40px] text-center md:text-left",
}
export const TWO_COL_VIDEOS_OUTSIDE_TAB_NEW = {
  ...TWO_COL_VIDEOS_OUTSIDE_TAB,
  title: "text-21 font-bold px-[24px] md:pl-0 max-md:pl-0 max-md:mb-[20px]",
  container:
    "twoColumnVideoWrapper twoColumnVideoWrapperNew container md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto lg:flex items-baseline",
}
export const SINGLE_VIDEO_OUTSIDE_TAB = {
  ...THREE_COL_VIDEOS,
  Content: "flex flex-col-reverse w-full",
}

export const GRID_WITH_LIST_GREEN_TITLE = {
  ...THREE_COL_GRID,
  containerWrapper:
    "climateContainer md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[20px] md:px-[15px]",
  container: "ContainerClimate block lg:flex md:flex-wrap mx-[-15px]",
  Content: "titleContent md:border-gray-400 px-[15px] flex-1 mb-[30px]",
  titleContent: "titleContent",
  description:
    "font-Regular text-[14px] md:text-[21px] mb-[10px] font-light tracking-[0.53px] md:tracking-[2.2px] leading-[21px] md:leading-[31.5px] text-left pl-[40px] pr-[15px] list-disc [&>div>ul>li>a]:text-purple font-bold hover:[&>div>ul>li>a]:underline [&>div>ul>li>a]:cursor-pointer hover:[&>div>ul>li>a]:text-orange [&>div>ul]:tracking-[0.53px] [&>div>ul]:list-disc [&>div>ul]:font-normal",
  title:
    "font-light font-Light text-[24px] lg:text-[48px] mb-[35px] font-Regular tracking-normal leading-[28.8px] md:leading-[57.6px] text-green text-left md:text-left lg:text-left px-[40px] md:pl-[15px] md:pl-[15px] md:pr-[20px]",
}

export const MULTIPLE_FOOTER_LINKLIST_WITHOUT_BG = {
  ...MULTIPLE_FOOTER_LINKLIST,
  containerWrapper: "containerWrapper py-[30px] lg:py-[50px] md:px-0",
}

export const MULTI_LINKS_WITHOUT_BG = {
  ...MULTI_LINKS,
  mainContainerWrapper: "mainContainerWrapper",
  containerWrapper: "containerWrapper py-[40px] px-[15px]",
}

export const MULTIPLE_FOOTER_LINKLIST_GREEN_UNDERLINE = {
  ...MULTIPLE_FOOTER_LINKLIST,
  mainContainerWrapper: "[&>div>div:nth-child(2)]:last:border-b-[0px]",
  containerWrapper:
    "containerWrapper pb-[35px] px-[15px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  Heading:
    "text-green font-Regular text-[36px] md:text-[48px] px-[15px] lg:px-0 mb-[50px] tracking-normal lg:tracking-[1.2px] font-light leading-[72px]",
  container: "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto flex flex-wrap border-b",
}
export const MULTIPLE_FOOTER_LINKLIST_WITHOUT_SPACE = {
  ...MULTIPLE_FOOTER_LINKLIST_WITHOUT_BG,
  Content: "w-full h-73 px-[20px] last:mb-[70px]",
  containerWrapper:
    "containerWrapper pt-[20px] pb-[40px] px-[15px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  title:
    "text-[14px] md:text-[21px] text-[#4f2170] tracking-[0.53px] md:tracking-[2.2px] font-bold mb-[10px] font-Regular md:mb-[30px] hover:text-orange hover:underline leading-[21px] md:leading-[31.5px]",
  container: "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto flex flex-wrap",
}

export const THREE_COL_LINK_GRID = {
  ...THREE_COL_GRID,
  containerWrapper:
    "climateContainer md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto mb-[30px] lg:mb-[0px] lg:px-[15px]",
  linkwrap:
    "linkwrap lg:grid lg:grid-cols-3 md:grid md:grid-cols-3 px-[20px] lg:px-[0px]",
  linkContainer: "linkContainer",
  Heading:
    " text-left text-[24px] mt-[-12px] font-light text-green mb-[35px] font-Light leading-[1.2] box-border lg:text-[48px] my-[45px] tracking-normal w-full md:text-[24px] px-[15px] md:px-[15px] lg:px-[0px]",
  headingWrapper: "climateWrapper ",
  container: "ContainerClimate md:block lg:flex md:flex",
}

export const TWO_COL_GRID_PURPLE_TEXT_DIVIDER = {
  ...THREE_COL_GRID,
  containerWrapper:
    "climateContainer md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[0px] md:px-[15px] py-[30px] lg:px-0 lg:py-[50px]",
  container: "container",
  linkwrap: "linkwrap md:grid md:grid-cols-2 px-[15px]",
  linkContainer: "linkContainer",
  headingWrapper:
    "climateWrapper max-w-[200px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px]",
  Heading:
    "text-purple font-MDLZBiteType text-[36px] md:text-[60px] tracking-normal font-light mb-[25px] text-center md:text-left",
}
export const THREE_COL_GRID_PURPLE_TEXT_DIVIDER = {
  ...THREE_COL_GRID,
  linkwrap: "linkwrap md:grid md:grid-cols-3",
  Heading:
    "text-purple font-MDLZBiteType text-[36px] md:text-[60px] mb-[50px] tracking-normal font-light text-center md:text-left",
  headingWrapper: "climateWrapper",
  containerWrapper:
    "climateContainer md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px] py-[50px]",
}
export const TWO_COL_GRID_PURPLE_TEXT_DIVIDER_WITH_BG = {
  ...TWO_COL_GRID_PURPLE_TEXT_DIVIDER,
  mainContainerWrapper: "bg-grayWhite",
}
export const THREE_COL_GRID_GREEN_HEADING_PURPLE_TEXT_DIVIDER = {
  ...THREE_COL_GRID_PURPLE_TEXT_DIVIDER,
  Heading:
    "text-green font-Light text-[24px] md:text-[48px] mb-[35px] tracking-normal",
}

export const TWO_COL_GRID_PURPLE_TEXT = {
  ...COL_GRID_PURPLE_TEXT,
  linkwrap: "linkwrap lg:grid lg:grid-cols-2",
  containerWrapper:
    "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px] lg:px-0 py-[30px] lg:py-[50px]",
}

export const THREE_COLUMN_VIDEO = {
  marketingApproachWrapper:
    "block md:block lg:flex md:flex-row flex-col mt-40 marketingAproachVideoWrap",
  description:'description',
}
export const THREE_ROW_TABLE = {
  multirowTable: "flex flex-col",
  description:'description',
}

export const FOUR_COL_WITH_HEADING = {
  ...defaultStyle,
  mainContainerWrapper: "bg-grayWhite",
  containerWrapper:
    "test containerWrapper py-[40px] px-[15px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  headingWrapper: "headingWrapper md:max-w-md lg:max-w-lg xl:max-w-xl",
  Content:
    "w-[27%] md:w-[23%] lg:w-[25%] pb-[25px] md:border-r-1 md:border-solid md:border-gray-400 last:border-none relative box-border b-r-0 md:first:pl-[15px] md:first:pr-[50px] mx-[30px] md:mx-[0px] md:px-[50px] md:last:pl-[50px] md:last:pr-[15px] ",
  container:
    "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto flex flex-wrap border-b-1 border-solid md:border-0 mb-[0px] md:mb-[90px] box-border pl-[35px] md:px-[60px] md:mx-[24px] lg:mx-[0px]",
  title:
    "md:text-[48px] text-[24px] mb-[10px] font-Light font-light tracking-normal text-green md:mb-[30px] leading-[28.8px] md:leading-[57.6px]  ",
  Heading:
    "text-purple font-MDLZBiteType text-[36px] md:text-[60px] px-[35px] md:px-[75px] mb-60 tracking-normal font-light md:px-[60px] mx-[0px] lg:mx-[0px]",
}

export const TWO_COLUMN_LINKS = {
  ...THREE_COL_GRID,
  containerWrapper:
    "ProcurementWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto border-b-0 !important",
  description:
    "Procurement text-black font-Regular italic text-[22px] mb-[10px] lg:mb-0 font-light tracking-[0.53px] leading-[33px] text-left",
  Content: "titleContent md:border-gray-400 p-[10px] pb-[25px] lg:pb-0 w-1/2",
  container: "flex",
}
export const TABS_TWO_COL_GRID_SECTION = {
  ...defaultStyle,
  containerWrapper: "col2MfgFacIlitiesContainerWrapr bg-grayWhite  ",
}

export const TABS_THREE_COL_GRID_SECTION = {
  ...defaultStyle,
  containerWrapper: "col3MfgFacIlitiesContainerWrapr ",
}
export const TWO_COLUMN_LINKS_SMALL_TITLE = {
  ...TWO_COL_VIDEOS_OUTSIDE_TAB,
  Content:
    "flex flex-col-reverse w-full md:w-full lg:w-1/2 lg:px-[20px] mb-[80px] lg:mb-[30px] relative",
  Heading:
    "text-purple font-MDLZBiteType text-[36px] md:text-[60px] px-[35px] md:px-[15px] tracking-normal font-light md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto mb-30 lg:mb-50",
  mediaVideoLink:
    "mediaVideoLink absolute max-md:ml-20 bottom-[-40px] lg:bottom-[-65px] [&>a]:!text-purple [&>a]:!font-bold [&>a]:!tracking-[0.53px] md:[&>a]:!tracking-[2.2px] hover:[&>a]:!text-orange hover:[&>a]:border-b-2 hover:[&>a]:no-underline",
  title: "text-21 font-bold px-[24px] pl-0 max-md:mb-[20px] lg:-mt-[20px]",
}

export const COCOA_LIFE_PILLER_DESCRIPTION = {
  mainContainerWrapper: "bg-[#faf3e7]",
  headingWrapper:"",
  containerWrapper:"w-full pb-[80px] px-[20px] lg:px-0",
  container: "lg:max-w-lg xl:max-w-[1196px] mx-auto flex flex-wrap justify-between",
  Content:"w-full lg:w-[32%]",
  title: "text-26 leading-[31.2px] text-purple font-BwSurco bg-Bisque mb-24",
  description: "text-20 leading-[24px] text-black font-BwSurco px-10",
}

export const COCOA_LIFE_PILLER_TWO_BOX = {
  mainContainerWrapper: "bg-[#faf3e7] pillers-description relative z-10",
  headingWrapper:"",
  containerWrapper:"w-full pt-[40px] pb-[100px] px-[20px] lg:px-0",
  container: "lg:max-w-lg xl:max-w-[1196px] mx-auto flex flex-wrap justify-between",
  Content:"w-full lg:w-[48%] mb-[20px] last:mb-0 lg:mb-0",
  title: "text-26 leading-[31.2px] text-purple font-BwSurco bg-Bisque mb-24",
  description: "text-20 leading-[24px] text-black font-BwSurco",
}
export const PROTECTING_TWO_COL_BOX = {
  mainContainerWrapper: "bg-[#B5BF5E] protecting-two-col relative z-10",
  headingWrapper:"",
  containerWrapper:"w-full pt-[48px] pb-[80px] px-[20px] lg:px-0",
  container: "lg:max-w-lg xl:max-w-[1196px] mx-auto flex flex-wrap justify-between",
  Content:"w-[48%] bg-purple rounded-[20px] overflow-hidden",
  title: "text-26 leading-[31.2px] text-purple font-BwSurco bg-Bisque mb-24",
  description: "text-20 leading-[24px] text-black font-BwSurco",
}

export const EMPOWERING_FOUR_COL_BOX = {
  mainContainerWrapper: "bg-[#faf3e7] empowering-wrap relative z-10",
  headingWrapper:"",
  containerWrapper:"w-full pt-[80px] pb-[80px] px-[20px] lg:px-0",
  container: "lg:max-w-lg xl:max-w-[1196px] mx-auto flex flex-wrap justify-between",
  Content:"w-[47%] lg:w-[32%] mb-[20px] last:mb-0 lg:mb-0",
  title: "text-26 leading-[31.2px] text-purple font-BwSurco bg-Bisque mb-24",
  description: "text-20 leading-[24px] text-black font-BwSurco text-center",
}

export const SUSTAINABLE_THREE_BOX = {
  mainContainerWrapper: "bg-[#FDC583] sustainable-box relative z-10",
  headingWrapper:"",
  containerWrapper:"w-full pt-[48px] pb-[80px] lg:pb-[60px] px-[20px] lg:px-0",
  container: "lg:max-w-lg xl:max-w-[1196px] mx-auto flex flex-wrap justify-between",
  Content:"w-full lg:w-[32%] mb-[20px] last:mb-0 lg:mb-0",
  title: "text-26 leading-[31.2px] text-purple font-BwSurco bg-Bisque mb-24",
description: "text-20 leading-[24px] text-black font-BwSurco",
}

export const EMPOWERING_THREE_COL_BOX = {
  mainContainerWrapper: "bg-[#4F2170] empowering-boxes relative",
  headingWrapper:"",
  containerWrapper:"w-full pt-0 px-[20px] lg:px-0",
  container: "lg:max-w-lg xl:max-w-[1196px] mx-auto flex flex-wrap gap-[20px] justify-between xl:[&>div:nth-child(4)]:w-[49%] xl:[&>div:nth-child(5)]:w-[49%] xl:[&>div:nth-child(6)]:mb-0 xl:[&>div:nth-child(7)]:mb-0 xl:[&>div:nth-child(8)]:mb-0",
  Content:"w-full md:w-[48%] xl:w-[32%] column bg-[#FDC583] mb-3 last:mb-0 rounded-[20px] p-[16px] xl:p-30 [&>div:nth-child(2)]:h-full flex justify-center",
  title: "text-26 leading-[31.2px] text-purple font-BwSurco bg-Bisque mb-24",
  description: "text-20 leading-[24px] text-black font-BwSurco flex items-center h-full",
  descriptionLink : "bg-Bisque text-[18px] leading-[27px] font-BwSurcoBold py-[16px] px-[32px] inline-block mx-auto rounded-full"
}

export const DELICIOUSLY_TWO_COL = {
  mainContainerWrapper: "bg-[#faf3e7] relative section-deliciously",
  headingWrapper:"",
  containerWrapper:"w-full pt-[40px] pb-[40px] px-[20px] lg:px-0",
  container: "lg:max-w-lg xl:max-w-[1196px] mx-auto flex flex-wrap justify-between xl:[&>*:nth-child(4)]:w-[48%] xl:[&>*:nth-child(5)]:w-[48%]",
  Content:"w-full lg:w-[46.5%] column mb-[20px] last:mb-0 lg:mb-0",
  title: "",
  description: "text-20 lg:text-18 xl:text-20 leading-[24px] text-black font-BwSurco tracking-normal text-center",
}


export const COMMUNITY_THREE_COL_GRID = {
  ...THREE_COL_GRID,
  mainContainerWrapper:"bg-[#4F2170]",
  containerWrapper:"climateContainer  xl:max-w-[1196px] mx-auto",
}

export const COMMUNITY_FOUR_COL_ICON_TEXT = {
  mainContainerWrapper:"nutrition-three-col mainContainerWrapper px-20 lg:px-0",
  containerWrapper:"containerWrapper lg:max-w-lg xl:max-w-[1196px] mx-auto relative",
  container:"container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 bg-[#FAF3E7] rounded-t-[20px] pt-[100px] lg:pt-[70px]",
  Content:"community_four_card basis-[33%] py-[40px] px-[30px] flex relative",
  Heading: "title text-[32px] leading-[38.4px] font-[400] font-MDLZBiteType uppercase text-[#36174D] absolute top-[40px] px-30 lg:px-40 z-100",
  title:"title text-[32px] leading-[38.4px] font-[400] font-MDLZBiteType uppercase text-[#36174D] min-h-[75px] mb-[24px]",
  description:"description",
  descriptionText:`descriptionText [&>p]:min-h-[75px] [&>p>img]:absolute [&>p]:pl-[75px] [&>p>img]:w-[75px] [&>p>img]:h-[75px] [&>p>img]:left-[35px] [&>p]:ml-[20px] [&>p]:mb-[20px] 
  [&>p>strong]:text-[#DB0961] [&>p>strong]:text-[32px] [&>p>strong]:leading-[38.4px] [&>p>strong]:uppercase [&>p]:font-MDLZBiteType [&>p>strong]:font-[400] [&>p>strong]:block [&>p]:text-[20px] [&>p]:leading-[24px] [&>p]:text-[#651935]`
}

export const COMMUNITY_TWO_COL_ICON_TEXT = {
  mainContainerWrapper:"nutrition-two-col mainContainerWrapper px-20 lg:px-0",
  containerWrapper:"containerWrapper lg:max-w-lg xl:max-w-[1196px] mx-auto",
  container:"container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 bg-[#FAF3E7]",
  Content:"community_four_card basis-[50%] py-[40px] px-[30px] flex relative",
  title:"title text-[32px] leading-[38.4px] font-[400] font-MDLZBiteType uppercase text-[#36174D] mb-[24px]",
  description:"description",
  descriptionText:`descriptionText [&>p]:min-h-[75px] [&>p>img]:absolute [&>p]:pl-[75px] [&>p>img]:w-[75px] [&>p>img]:h-[75px] [&>p>img]:left-[35px] [&>p]:ml-[20px] [&>p]:mb-[20px] 
  [&>p>strong]:text-[#DB0961] [&>p>strong]:text-[32px] [&>p>strong]:leading-[38.4px] [&>p>strong]:uppercase [&>p]:font-MDLZBiteType [&>p>strong]:font-[400] [&>p>strong]:block [&>p]:text-[20px] [&>p]:leading-[24px] [&>p]:text-[#651935]`
}

export const INDIA_MAP_CARDS = {
  mainContainerWrapper: "bg-[#D4B7EC] india-map-cards relative",
  headingWrapper:"",
  containerWrapper:"w-full pt-[20px] pb-[60px] px-[20px] lg:px-0",
  container: "lg:max-w-lg xl:max-w-[1196px] mx-auto flex flex-wrap justify-between px-0 xl:px-[6%]",
  Content:"w-full lg:w-[48.5%] column bg-[#FDC583] mb-24 rounded-[20px] p-[16px] xl:p-30 [&>div:nth-child(2)]:h-full flex justify-center",
  title: "",
  description: "text-20 leading-[24px] text-black font-BwSurco flex items-center h-full text-purple",
  descriptionLink : ""
}
	export const OUR_ROADMAP_SECTION = {
  mainContainerWrapper:"mainContainerWrapper roadmap_section bg-[#FAF3E7] scroll-mt-[150px] pt-30",
  containerWrapper:"containerWrapper container mx-auto",
  headingWrapper: "headingWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  Heading:
    "text-purple font-MDLZBiteType text-[48px] leading-[57.6px] px-[35px] md:px-[15px] mb-40 tracking-normal font-light text-center",
  container:
    "roadmap-cards md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto pb-40 lg:pb-0",
  Content:
    "twocol relative",
  Content2:
    "text-[14px] font-Regular font-bold font-stretch tracking-[0.022em] mb-[44px] mt-[0px] text-black hover:text-red-700 hover:underline",
  title:
    "md:text-[48px] text-[24px] mb-[10px] font-Light font-light tracking-normal text-green md:mb-[30px] leading-[28.8px] md:leading-[57.6px] ",
  Button: "flex flex-col items-center justify-center",
  Button2:
    "font-bold text-lg text-center cursor-pointer uppercase font-Regular bg-purple-900 border-2 rounded-full w-[160px] h-[60px] px-45 py-14  box-border text-white hover:opacity-[70%]",
  description:
    "roadmap_desc text-[14px] md:text-[21px] text-black font-BwSurco mb-[10px] font-light tracking-[0.53px] [&>div>p>a]:font-bold [&>div>p>a]:tracking-[0.53px] md:[&>div>p>a]:!tracking-[2.2px] [&>div>p>a:hover]:underline [&>div>p>strong]:font-bold",
}